export default __webpack_public_path__ + "static/gitlens-6280715ae711df135a7ddb716f1b877e.png";